import { PatientRecommendationsRepository } from "../infrastructure/api/PatientRecommendationsRepository";

export function getPatientRecommendations(patientId: string, isCouple?: boolean) {
  const repo = new PatientRecommendationsRepository();
  return repo.getRecommendations(patientId, isCouple);
}

export function refreshPatientRecommendations(patientId: string, isCouple?: boolean) {
  const repo = new PatientRecommendationsRepository();
  return repo.refreshRecommendations(patientId, isCouple);
}
